



































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { SessionDataObject } from "@/types/interfaces.ts";
import sessionVuexModule from "@/store/vuex-modules/getSessionData";
import {
    startOfToday,
    parse,
    isBefore,
    isAfter,
    isWithinInterval,
    formatDistance,
    subMinutes,
    differenceInSeconds
} from "date-fns";

const sessionStore = getModule(sessionVuexModule);

@Component({})
export default class SessionScheduleItem extends Vue {
    showingBios = false;
    isSessionActive = false;
    sessionLabelInterval = 0;
    timeLabel = "";

    @Prop({ default: {} })
    session!: SessionDataObject;

    get pageConfig() {
        return this.$store.getters.getPageOptions("sessions");
    }
    get sessionDateTime() {
        const iso = this.session.startTimeISO;
        return new Date(iso);
    }

    get sessionEarlyAccessMinutes() {
        return sessionStore.sessionEarlyAccessMinutes;
    }

    get isSessionOver() {
        if (!this.session.date) return true;

        const today = startOfToday();
        const rightNow = window.MgServerTime;
        const date = parse(
            this.session.date,
            "yyyy-MM-dd",
            window.MgServerTime
        );

        const endIso = this.session.endTimeISO;
        const endTime = new Date(endIso);

        if (isBefore(date, today)) {
            return true;
        } else if (isAfter(date, today)) {
            return false;
        } else {
            return isBefore(endTime, rightNow);
        }
    }

    get startTimeAdjusted() {
        return subMinutes(this.sessionDateTime, this.sessionEarlyAccessMinutes);
    }

    get isSpeakeasy() {
        return Boolean(this.session && this.session.speakeasyType);
    }

    // Watchers
    @Watch("isSessionOver")
    isSessionOverChanged() {
        // TODO:
        // potentially make `isSessionOver` an item in component data and update its value on an interval
        // that way we can use this watcher to move the item into the onDemand list in real time.
    }

    created() {
        this.sessionLabelInterval = window.setInterval(() => {
            this.handleActiveSessionCheck();
        }, 1000);
    }

    beforeDestroy() {
        window.clearInterval(this.sessionLabelInterval);
    }

    handleActiveSessionCheck() {
        this.isSessionActive = this.checkIfSessionIsActive();
        this.timeLabel = formatDistance(
            window.MgServerTime,
            this.sessionDateTime
        );
    }

    checkIfSessionIsActive() {
        const iso = new Date(this.session.startTimeISO);
        if (!Vue.prototype.MgIsToday(iso)) return false;

        const endTime = new Date(this.session.endTimeISO);

        const timeSinceAdjusted = differenceInSeconds(
            window.MgServerTime,
            this.startTimeAdjusted
        );
        const hasStarted = Boolean(timeSinceAdjusted > -1);

        const isActive = isWithinInterval(window.MgServerTime, {
            start: this.startTimeAdjusted,
            end: endTime
        });

        // TODO - this is being logged twice - need to FIX.
        // console.log(timeSinceAdjusted, "timeSinceAdjusted");

        return hasStarted || isActive;
    }

    toggleBiographies() {
        this.showingBios = !this.showingBios;
    }

    watchSession() {
        this.$router.push({
            name: "Session",
            params: {
                id: this.session.insightId
            }
        });
    }

    goToSession() {
        if (!this.isSessionActive) return;

        let urlIsUrl = false;

        if (this.session.url) {
            try {
                new URL(this.session.url);
                urlIsUrl = true;
            } catch (error) {
                console.error(error);
            }
        }

        if (urlIsUrl) {
            window.open(this.session.url, undefined, "noopener,noreferrer");
        } else if (this.isSpeakeasy) {
            this.$router.push(`/meeting/SESSION${this.session.insightId}`);
        } else {
            const timeSinceStart = differenceInSeconds(
                window.MgServerTime,
                this.startTimeAdjusted
            );

            this.$router.push({
                name: "Session",
                params: {
                    id: this.session.insightId,
                    startVideoAt: `${timeSinceStart}`
                }
            });
        }
    }
}
